import { render, staticRenderFns } from "./referrals.vue?vue&type=template&id=3f74cc48&scoped=true&"
import script from "./referrals.vue?vue&type=script&lang=js&"
export * from "./referrals.vue?vue&type=script&lang=js&"
import style0 from "./referrals.vue?vue&type=style&index=0&id=3f74cc48&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f74cc48",
  null
  
)

export default component.exports